import { Tag } from "@carbon/react";
import { OverflowMenuVertical } from "@carbon/react/icons";

import { subscriptionBillingMethod, subscriptionStatus } from "../../enums";

export const subscriptionDisplayFormatter = (item) => {
  const statusIndicator =
    item.status === subscriptionStatus.active
      ? { statusText: "Active", statusType: "green" }
      : item.status === subscriptionStatus.unpaid
      ? { statusText: "Unpaid", statusType: "red" }
      : item.status === subscriptionStatus.overdue
      ? { statusText: "Overdue", statusType: "red" }
      : { statusText: "Cancelled", statusType: "gray" };

  const billing_methodIndicator =
    item.billing_method == subscriptionBillingMethod.auto
      ? { statusText: "Auto", statusType: "teal" }
      : { statusText: "Send", statusType: "high-contrast" };

  return {
    ...item,
    customer: item.customer.email,
    billing_method: (
      <Tag type={billing_methodIndicator.statusType}>
        {subscriptionBillingMethod[item.billing_method]}
      </Tag>
    ),
    status: (
      <Tag className="transaction-status" type={statusIndicator.statusType}>
        <span>{statusIndicator.statusText}</span>
        <div
          style={{ backgroundColor: statusIndicator.statusType }}
          className="status-indicator"
        />
      </Tag>
    ),
    product: <strong>{item.product_name}</strong>,
    description: <strong>{item.description}</strong>,
    date: <span className="date--oneline">{item.date}</span>,
    // more: <OverflowMenuVertical />,
  };
};
